var exports = {
  "kL": "GuildModerationTab.module__container___a2lzQk",
  "uW": "GuildModerationTab.module__section___a2lzQk",
  "Gf": "GuildModerationTab.module__sectionTitle___a2lzQk",
  "yV": "GuildModerationTab.module__sectionDescription___a2lzQk",
  "dg": "GuildModerationTab.module__sectionDescriptionMultiline___a2lzQk",
};

module.exports = exports;
